<template>
  <div>
    <div class="boxed-category" v-if="showExtra">
      <md-subheader>Suncorp Csv Actions</md-subheader>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-button class="md-primary" @click="openSuncorpLocateLeadDialog">
            <md-icon>app_registration</md-icon>
            Locate Lead
          </md-button>
          <md-button class="md-primary" @click="openSuncorpValidationDialog">
            <md-icon>app_registration</md-icon>
            Validate
          </md-button>
          <md-button class="md-primary" @click="openSuncorpDialog">
            <md-icon>app_registration</md-icon>
            Import
          </md-button>
        </div>
      </div>
    </div>

    <suncorp-csv-upload-dialog
      :show-dialog="showSuncorpLocateLeadDialog"
      :dialog-title="'Locate Lead Suncorp CSV'"
      :dialog-text="'Upload CSV for processing.'"
      :import-action="'locate_lead'"
      @file-uploaded="suncorpUpload"
      @close-dialog="closeSuncorpLocateLeadDialog"
    />
    <suncorp-csv-upload-dialog
      :show-dialog="showSuncorpValidationDialog"
      :dialog-title="'Validate Suncorp CSV'"
      :dialog-text="'Upload CSV for validation.'"
      :import-action="'validate'"
      @file-uploaded="suncorpUpload"
      @close-dialog="closeSuncorpValidationDialog"
    />
    <suncorp-csv-upload-dialog
      :show-dialog="showSuncorpDialog"
      :dialog-title="'Import Suncorp CSV'"
      :dialog-text="'Import Suncorp CSV.'"
      :import-action="'save'"
      @file-uploaded="suncorpUpload"
      @close-dialog="closeSuncorpDialog"
      needSelectDate
    />
  </div>
</template>

<script>
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import AlertDialog from "../components/Dialogs/AlertDialog.vue";
import WaitingDialog from "../components/Dialogs/WaitingDialog.vue";
import SuncorpCsvUploadDialog from "@/components/Dialogs/SuncorpCsv/SuncorpCsvUploadDialog"

export default {
  components: {
    SuncorpCsvUploadDialog,
    WaitingDialog,
    AlertDialog,
    ConfirmDialog,
  },
  data() {
    return {
      showSuncorpLocateLeadDialog: false,
      showSuncorpValidationDialog: false,
      showSuncorpDialog: false,
    }
  },
  props: {
    showExtra: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    openSuncorpLocateLeadDialog() {
      this.showSuncorpLocateLeadDialog = true;
    },
    closeSuncorpLocateLeadDialog() {
      this.showSuncorpLocateLeadDialog = false;
    },
    openSuncorpValidationDialog() {
      this.showSuncorpValidationDialog = true
    },
    closeSuncorpValidationDialog(){
      this.showSuncorpValidationDialog = false;
    },
    openSuncorpDialog() {
      this.showSuncorpDialog = true;
    },
    closeSuncorpDialog() {
      this.showSuncorpDialog = false;
    },
    async suncorpUpload(payload, action) {
      this.$modal.show(WaitingDialog, {
        title: "Importing...",
        message: "Please wait while we are importing the file.",
      })
      payload = { ...payload, action };
      try {
        const result = await this.$store.dispatch('import_suncorp_csv', payload);
        this.$modal.submit();

        const message = await this.handleResponse(result);

        this.$modal.submit();
        this.$modal.show(AlertDialog, {
          title: "Successful",
          message
        });

      } catch (error) {
        const message = await this.handleResponse(error.response);
        this.$modal.submit();
        this.$modal.show(ConfirmDialog, {
          title: "Import result",
          message: message,
          confirmText: "Confirm",
        })
      }
    },
    async handleResponse(response) {
      const contentType = response.headers['content-type'];
      const contentDisposition = response.headers['content-disposition'];

      if (contentType.includes('application/json')) {
        // Parse JSON response
        const text = await response.data.text();
        const jsonData = JSON.parse(text);
        let message = "";
        if (jsonData && Array.isArray(jsonData.errors)) {
          message = "<ul>";
          message += jsonData.errors.map( error => `<li>${error}</li>`).join("");
          message += "</ul>";
        } else {
          message = jsonData.error;
        }
        return message;
      } else if (contentDisposition && contentDisposition.includes('attachment')) {
        // Handle file download
        const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
        const filename = filenameMatch ? filenameMatch[1] : 'downloaded_file';

        const blob = response.data;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Use extracted filename
        document.body.appendChild(link);
        link.click();
        link.remove();
        return `File ${filename} downloaded successfully`;
      } else if (contentType.includes('text/plain')) {
        // Handle plain text response (e.g., boolean success)
        const text = await response.data.text();
        if (text === 'true') {
          return 'Import Successfully';
        }
      }
      return 'Unknown response type'
    },
  }
}
</script>